import { render } from "./WhatsappIntegration.vue?vue&type=template&id=7b1f9a50&scoped=true&ts=true"
import script from "./WhatsappIntegration.vue?vue&type=script&lang=ts"
export * from "./WhatsappIntegration.vue?vue&type=script&lang=ts"

import "./WhatsappIntegration.vue?vue&type=style&index=0&id=7b1f9a50&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1f9a50"]])

export default __exports__